const region = "us-east-1";
const origin = window.location.origin;

const qa = {
  appSettingsData: {
    // generate a file format limit of video file
    federatedEngageAIProvider: "wl-idp-qa-engage-gpt-ident-prov",
  },

  amplify_config: {
    Auth: {
      mandatorySignIn: true,
      region: region,
      userPoolId: "us-east-1_YhQ44g3h",
      userPoolWebClientId: "4l2gej7vns5sfhp8t8at2p8e1e",
    },
    oauth: {
      domain: "auth.qa.gpt.wl-engage.com",
      scope: [],
      redirectSignIn: `${origin}/chat`,
      redirectSignOut: `${origin}/chat`,
      responseType: "code",
      clientId: "4l2gej7vns5sfhp8t8at2p8e1e",
    },
    API: {
      endpoints: [
        {
          name: "engage-gpt",
          // endpoint: "https://api.dev.wl-dms.com",
          endpoint: "https://api.qa.gpt.wl-engage.com",
          region: region,
        },
      ],
    },
  },
};
// type demoType = typeof demo

export type QaType = typeof qa;
export default qa;
